/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';
import { useLazyQuery } from '@apollo/client';

import { formatValue } from '../../../../../core/utils/formatValue';
import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { GET_ORDERS } from './graphql';

export function useGetOrders({ userId }) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [totalOrderQuantity, setTotalOrderQuantity] = useState(0);
  const [GetOrders, { loading: apiLoading, error: apiError }] = useLazyQuery(
    GET_ORDERS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function getOrders({
    newUserId,
    offset = 0,
    limit = 5,
    filters = {
      status: null,
      commerce: null,
      orderCode: null,
      itemQuantity: null,
    },
  }) {
    try {
      const res = await GetOrders({
        variables: {
          userId: newUserId || userId,
          offset,
          limit,
          filters,
        },
      });
      if (res.data.allOrders.code === 200) {
        setTotalOrderQuantity(res.data.allOrders.totalOrderQuantity);
        const newArrayOrders = res.data.allOrders.orders.map((order) => {
          const newOrder = { ...order };
          newOrder.totalValue = formatValue(newOrder.totalValue);
          return newOrder;
        });
        setApiData(newArrayOrders);
      } else {
        setErrorMessage(res.data.allOrders.message);
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    if (userId) {
      getOrders({
        userId,
        offset: 0,
        limit: 5,
      });
    }
  }, [userId]);

  return {
    getOrders,
    orders: apiData,
    totalOrderQuantity,
    loading: isLoading,
  };
}
